import { Action } from '../../actions/core/action';
import { ResponseErrorData } from '../../models/rest.model';

export class AuthenticationError implements Action {
  constructor(public error: ResponseErrorData) {}
}

export class AuthorizationError implements Action {
  constructor(public error: ResponseErrorData) {}
}

export class TimeOutError implements Action {
  constructor(public error: ResponseErrorData){}
}

export class GenericError implements Action {
  constructor(public error: ResponseErrorData, public isPayment?: boolean) {}
}

export class MasterPassError implements Action {
  constructor(public errorCode:string, public errorMessage:string) {}
}



// WEBPACK FOOTER //
// src/app/common/services/error/error.action.ts